module.exports = "/legacy/dc8cb9c042e11035960d5d52ef9d1e88.svg";